import { styles } from 'consts';
import styled from 'styled-components';
import { PROGRESS } from '../../config/config';

const { gray, statusBarColor, breakLineColor, fontMontserrat } = styles;

const Container = styled.div`
  display: none;
  border-top-right-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
  color: ${gray};
  margin: 3.25rem 1.5625rem 3.25rem 1.4375rem;
  flex-basis: 17.8125rem;
  color: ${statusBarColor};
  font-family: ${fontMontserrat};
  position: relative;
  min-height: 15rem;

  @media (min-width: 768px) {
    display: block;
  }
`;

const Amount = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.1875rem;
`;

const AmountText = styled.p`
  height: 1.5rem;
  font-family: ${fontMontserrat};
  font-size: 1rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${statusBarColor};
`;

const Integer = styled.span`
  height: 1.5rem;
  font-family: ${fontMontserrat};
  font-size: 1.125rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  color: ${statusBarColor};
`;

const Decimal = styled.span`
  height: 1rem;
  font-family: ${fontMontserrat};
  font-size: 0.875rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: right;
  color: ${statusBarColor};
  text-transform: uppercase;
  letter-spacing: 0.015625rem;
`;

const OrderDescription = styled.div`
  font-size: 0.75rem;
  line-height: 1.25rem;
  width: 17.8125rem;

  .statusbar__description {
    font-weight: bold;
    overflow-wrap: break-word;
  }
`;

const Item = styled.p`
  height: 1.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: ${statusBarColor};
`;

const ItemBold = styled.p`
  min-height: 1.5rem;
  font-family: ${fontMontserrat};
  font-size: 0.875rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.81;
  letter-spacing: normal;
  color: ${statusBarColor};
`;

const LineBreak = styled.div`
  margin: 0.8125rem 0;
  height: 0.0625rem;
  background: ${breakLineColor};
`;

const buttonWrapperExtendMinHeight = 1;

const buttonWrapperDisabledMethod = 2;

const buttonWrapperMinHeight = 3;

const setTop = ({
  isVisible,
  showPaymentNotification,
  progress,
}: {
  isVisible: boolean;
  showPaymentNotification: boolean;
  progress: number;
}) => {
  if (!isVisible) {
    if (
      showPaymentNotification &&
      PROGRESS.SELECT_BLIK_METHOD <= progress &&
      PROGRESS.BLIK_CODE_VERIFICATION >= progress
    ) {
      return -buttonWrapperExtendMinHeight;
    }

    if (progress === PROGRESS.NOT_SELECTED_PAYMENT_METHOD) {
      return -buttonWrapperDisabledMethod;
    }

    if (progress > PROGRESS.NOT_SELECTED_PAYMENT_METHOD) {
      return -buttonWrapperMinHeight;
    }
    return 0;
  }
  return 0;
};

const PaymentWrapper = styled.div``;

const Animation = styled.div<{
  isVisible: boolean;
  showPaymentNotification: boolean;
  progress: number;
}>`
  width: 17.8125rem;
  position: relative;
  top: 8.25rem;
  top: ${setTop}rem;
  transition: top 400ms ease-in-out;
`;

export {
  Container,
  Amount,
  AmountText,
  Integer,
  Decimal,
  OrderDescription,
  Item,
  ItemBold,
  LineBreak,
  Animation,
  PaymentWrapper,
};
